export const meta = {
  title: 'MrQ',
  description: `Log in to your MrQ account to enjoy popular slots, live casino, and exciting bingo games. New here? Sign up today and start playing!`
};
